import { ReactElement } from "react";
import styled from "styled-components";
import { cardSurface } from "../../../atoms/Card";

interface AudioData {
  url?: string;
  caption?: string;
}

const Box = styled.figure`
  ${cardSurface}
  background: var(--app-color-surface-tint, white);
  margin: 0;
  padding: 12px 14px;
`;

// Native <audio controls> is the deliberate phase-1 choice: reliable on the Ionic
// webview, zero dependencies, accessible controls for free.
const Player = styled.audio`
  width: 100%;
  display: block;
`;

const Caption = styled.figcaption`
  font-size: 13px;
  color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.6);
  margin-top: 6px;
  text-align: center;
`;

const AudioBlock = ({ data }: { data: AudioData }): ReactElement | null => {
  if (!data.url) return null;
  return (
    <Box>
      <Player controls preload="none" src={data.url} />
      {data.caption ? <Caption>{data.caption}</Caption> : null}
    </Box>
  );
};

export default AudioBlock;
